import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

const GoogleAuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { completeOAuthLogin } = useAuth();
  const handledRef = useRef(false);

  useEffect(() => {
    if (handledRef.current) return;
    handledRef.current = true;

    const params = new URLSearchParams(location.hash.replace("#", ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/auth");
      return;
    }

    const exchangeSession = async () => {
      try {
        const response = await api.post("/auth/google", { session_id: sessionId });
        completeOAuthLogin(response.data.token, response.data.user);
        window.history.replaceState({}, document.title, window.location.pathname + window.location.search);
        navigate("/");
      } catch (error) {
        toast.error("Google sign-in failed.");
        navigate("/auth");
      }
    };

    exchangeSession();
  }, [completeOAuthLogin, location.hash, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="google-auth-callback">
      <div className="text-sm text-muted-foreground" data-testid="google-auth-loading">
        Finishing Google sign-in...
      </div>
    </div>
  );
};

export default GoogleAuthCallback;
